import { createDeliveryQueue } from "./queue";
import { isServer } from "./shared";
import { Tracker } from "./types";

interface Umami {
  track(
    eventName: string,
    eventData?: Record<string, string | number | boolean | undefined>,
  ): void;
}

declare global {
  interface Window {
    umami?: Umami;
  }
}

const umamiDisabledKey = "umami.disabled";

const enqueue = createDeliveryQueue<Parameters<Umami["track"]>>(
  (args) => window.umami!.track(...args),
  () => Boolean(window.umami),
);

class UmamiTracker implements Tracker {
  init() {}

  isEnabled(): boolean {
    if (isServer) {
      return false;
    }

    try {
      return !localStorage.getItem(umamiDisabledKey);
    } catch {
      // Storage access itself throws where it is partitioned or blocked.
      return true;
    }
  }

  trackEvent(
    eventName: string,
    props?: Record<string, string | number | boolean | undefined>,
  ) {
    if (isServer || !this.isEnabled()) {
      return;
    }

    /* eslint-disable-next-line no-console */
    console.debug(`Tracking umami event: %c${eventName}`, "color: #1A9883");

    enqueue([eventName, props]);
  }

  disable(): void {
    try {
      localStorage.setItem(umamiDisabledKey, "1");
    } catch {
      // Nothing else to fall back to; the tracker simply stays enabled.
    }
  }
}

export default UmamiTracker;
